"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _fa = require("react-icons/fa6");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

class GroupTitle extends _react.default.Component {
  render() {
    const titleStyles = {
      display: 'block',
      fontSize: this.props.isMobile ? '18px' : '15px',
      lineHeight: this.props.isMobile ? 'initial' : '75px',
      letterSpacing: this.props.isMobile ? '1.7px' : '0',
      fontWeight: '300',
      margin: this.props.isMobile ? '5px 0 0' : 0,
      color: this.props.listOpen && this.props.isMobile ? '#fff' : 'inherit',
      transition: this.props.isMobile ? 'all 0.25s ease-in-out' : '0s',
      cursor: 'pointer'
    };
    const caretUp = /*#__PURE__*/_react.default.createElement(_fa.FaAngleUp, {
      size: 20,
      className: "caret-up",
      style: {
        margin: '0 0 5px 5px',
        float: 'right'
      }
    });
    const caretDown = /*#__PURE__*/_react.default.createElement(_fa.FaAngleDown, {
      size: 20,
      className: "caret-down",
      style: {
        margin: '0 0 5px 5px',
        float: 'right'
      }
    });
    const arrowStyle = {
      caret: this.props.listOpen ? caretUp : caretDown
    };
    const mobileTitleStyles = {
      width: '60%',
      paddingTop: '10px'
    };
    const padd = this.props.isMobile ? this.props.listOpen ? '10px 15px' : '6px 15px' : '0 25px 0 10px';
    titleStyles.padding = padd;
    if (this.props.href) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: encodeURI(this.props.href),
        className: 'group-list-title' + (this.props.isMobile ? ' text-left' : '') + (this.props.className ? this.props.className : ''),
        style: titleStyles
      }, this.props.title);
    }
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      style: titleStyles,
      className: 'group-list-title' + (this.props.isMobile ? ' text-left' : '') + (this.props.className ? this.props.className : '') + ' list-open-' + this.props.listOpen,
      onClick: this.props.toggleOpen,
      id: `${this.props.title}`
    }, this.props.title, this.props.isMobile ? arrowStyle.caret : null, /*#__PURE__*/_react.default.createElement("span", {
      style: this.props.isMobile ? mobileTitleStyles : null
    })), this.props.listOpen && this.props.isMobile ? /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-item-border",
      style: {
        marginTop: '-3px',
        borderBottom: '3px solid #f0ab00',
        width: '90%',
        margin: '-3px 0 0 14px',
        cursor: 'pointer'
      }
    }) : /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-item-border"
    }));
  }
}
exports.default = GroupTitle;
GroupTitle.propTypes = {
  title: _propTypes.default.string,
  href: _propTypes.default.string,
  className: _propTypes.default.string,
  toggleOpen: _propTypes.default.func,
  listOpen: _propTypes.default.bool,
  isMobile: _propTypes.default.bool
};